export enum CloudFileQueryKey {
    CloudFileDetails = "cloud-file-details"
}
